import SquareIcon from "@mui/icons-material/Square";
import './filters.css';
const menu = [
  {
    id: 1,
    title: "Available Beds",
    category: "availableBed",
    type:'AVAILABLE_BEDS',
    icon:<SquareIcon className="availableBed"/>
  },
  {
    id: 2,
    title: "Guests on Due",
    category: "dueGuests",
    type:'DUE_GUESTS',
    icon:<SquareIcon/>
  },
  {
    id: 3,
    title: "Guests-In Notice",
    category: "inNotice",
    type:'IN_NOTICE',
    icon:<SquareIcon/>
  },
  {
    id: 4,
    title: "Guests-With No Due",
    category: "activeGuests",
    type:'ACTIVE_WITHOUTDUE',
    icon:<SquareIcon/>
  },
  {
    id: 5,
    title: "Exceeded Checkout Date",
    category: "  checkoutExceed",
    type:'CHECKOUT_EXCEED',
    icon:<SquareIcon/>
  },
  {
    id: 6,
    title: "Today’s Checkouts",
    category: "todayCheckout",
    type:'TODAY_CHECKOUT',
    icon:<SquareIcon/>
  },
];
export default menu;
